import { Calendar, Users, LayoutGrid, Megaphone, CheckCircle2, Link2, Shield, Smartphone } from "lucide-react";

const features = [
  {
    icon: Calendar,
    title: "Scheduling that asks for you",
    description: "Add the match or the Tuesday training once. Everyone gets the request straight away, and recurring sessions repeat themselves.",
  },
  {
    icon: CheckCircle2,
    title: "Automatic RSVPs and reminders",
    description: "Players answer in one tap from the email, no account needed. Anyone who ignores it gets a nudge, so you stop counting heads in a group chat.",
  },
  {
    icon: LayoutGrid,
    title: "Lineup builder on the pitch",
    description: "Pick a formation, drag names into place. Only the players who said yes are on the bench, so the team you pick is the team that turns up.",
  },
  {
    icon: Users,
    title: "One roster, no limit",
    description: "Positions, shirt numbers, contact details and who has joined yet, in one list. Unlimited players and staff on the free plan.",
  },
  {
    icon: Megaphone,
    title: "Announcements people read",
    description: "Post the pitch change or the kit reminder, pin what matters, and it reaches the squad by email and push instead of scrolling past.",
  },
  {
    icon: Link2,
    title: "Joining takes seconds",
    description: "Send a link, share a code or hold up a QR at training. Nothing to download before someone can respond.",
  },
  {
    icon: Shield,
    title: "Sensible permissions",
    description: "Owners, coaches, managers, players and parents each see what they should. Personal details stay with the staff.",
  },
  {
    icon: Smartphone,
    title: "Made for the sideline",
    description: "Fast on a cold phone with one bar of signal. Add it to your home screen and it behaves like an app.",
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 md:py-32 relative">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            Team scheduling, RSVPs and lineups in one place
          </h2>
          <p className="text-muted-foreground text-lg">
            Everything a coach actually does in a week, without the club admin, invoicing and registration you never asked for.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl bg-card border border-border/60 hover:border-primary/40 hover:shadow-[0_0_28px_-4px_hsl(var(--primary)/0.35)] transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <feature.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-display font-semibold text-foreground mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
